import type { Venue as GQLVenue } from '@/generated/graphql';
import { Checkout } from '@vp/common';
import * as VenueRoom from '@/types/VenueRoom';
import * as Attachment from '@/types/Attachment';
import { take } from '@/helpers/takePayload';

export interface Venue {
  id?: number;
  name?: string;
  url?: string;
  timezone?: string;
  currency?: string;
  locale?: string;
  salesTax?: number;
  processingFee?: number;
  processingFeePercentage?: number;
  includeCcFee?: boolean;
  includeTaxFee?: boolean;
  includeConvenienceFee?: boolean;
  replyTo?: string;
  address?: Checkout.Address.Address;
  rooms?: VenueRoom.VenueRoom[];
  logo?: Attachment.Attachment;
}

export const getNew = (): Venue => ({
  name: '',
  url: '',
  timezone: 'America/New_York',
  currency: 'usd',
  locale: 'en',
  salesTax: 0,
  processingFee: 0.3,
  processingFeePercentage: 2.9,
  replyTo: '',
  address: Checkout.Address.getNew(),
  rooms: [VenueRoom.getNew()],
});

export const fromGql = (gqlVenue: GQLVenue): Venue => ({
  ...(take(
    gqlVenue,
    'id',
    'name',
    'url',
    'timezone',
    'currency',
    'locale',
    'salesTax',
    'processingFee',
    'processingFeePercentage',
    'includeCcFee',
    'includeTaxFee',
    'includeConvenienceFee',
    'replyTo',
  ) as Venue),
  address: gqlVenue.address ? Checkout.Address.fromGql(gqlVenue.address) : Checkout.Address.getNew(),
  rooms: gqlVenue.rooms ? gqlVenue.rooms.map(VenueRoom.fromGql) : [],
  logo: gqlVenue.logo ? Attachment.fromGql(gqlVenue.logo) : undefined,
});
